<template>
  <infinity-page
    icon="mdi-clipboard-text"
  >
    <template #title>
      <h1 style="font-weight: 300; font-family: lato; font-weight: bold; letter-spacing: initial;">
        Events
      </h1>
    </template>

    <v-container>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      />
    </v-container>
    <infinity-events :search="search" />
  </infinity-page>
</template>
<script>
  export default {
    name: 'EventsView',
    data: () => {
      return {
        search: '',
      }
    },
    mounted () {
    },
  }
</script>
